import { DillPaymentMethod, formatMoney } from '@dill/dill-shared/dist/src';
import { X, LightbulbFilament } from 'phosphor-react';
import React from 'react';
import { COLORS } from '../../../utils/colors';
import { AppButton } from '../../general/AppButton/AppButton';
import { DillButton } from '../../general/Dill/DillButton';
import { Modal } from '@mui/material';

const PaymentConfirmationModal = ({
  open,
  handleClose = () => {},
  handlePayNow = () => {},
  paymentDetails,
  isApplyToOldest = false,
  invoiceCount = 0,
  totalDiscount = 0,
  invoiceSubtotal = 0,
  excessAmount = 0,
  creditsApplied = 0,
}: {
  open: boolean;
  handleClose: () => void;
  handlePayNow?: () => void;
  paymentDetails?: {
    paymentTo: string;
    paymentFrom: string;
    totalPayment: number;
    paymentMethod: DillPaymentMethod;
  };
  isApplyToOldest?: boolean;
  invoiceCount?: number;
  totalDiscount?: number;
  invoiceSubtotal?: number;
  excessAmount?: number;
  creditsApplied?: number;
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-80 w-[85vw] md:w-4/12 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg flex-col px-3 py-1">
        <div className="flex justify-between items-center w-full px-2">
          <h3 className="font-semibold TEXT_PRIMARY-CLR text-lg">Payment Confirmation</h3>
          <AppButton
            type="FLAT"
            buttonStyles={{ padding: '0px', margin: '5px 2px' }}
            icon={<X color={COLORS.GREY_300} size={30} />}
            onClick={handleClose}
          />
        </div>
        <div className="py-3 px-4 border-b border-gray-200">
          <div className="flex justify-between pb-4">
            <div className="font-medium GREY_500-CLR">To</div>
            <p className="TEXT_PRIMARY-CLR font-semibold capitalize text-lg">
              {paymentDetails?.paymentTo}
            </p>
          </div>
          <div className="flex justify-between pb-4">
            <div className="font-medium GREY_500-CLR">From</div>
            <p className="TEXT_PRIMARY-CLR font-semibold capitalize text-lg">
              {paymentDetails?.paymentFrom}
            </p>
          </div>

          <div className="flex justify-between pb-4">
            <div className="font-medium GREY_500-CLR">Method</div>
            <p className="TEXT_PRIMARY-CLR font-semibold capitalize text-lg">
              {paymentDetails?.paymentMethod.type === 'BANK_ACCOUNT'
                ? 'Bank Transfer'
                : paymentDetails?.paymentMethod.type === 'CREDIT_CARD' &&
                  paymentDetails?.paymentMethod.cardType === 'CREDIT'
                ? 'Credit Card'
                : 'Debit / Other Card'}
            </p>
          </div>

          {isApplyToOldest && invoiceCount > 0 && (
            <div className="w-full pb-4">
              <div className="flex flex-col rounded-xl bg-gray-50 px-5 py-3">
                <div className="flex flex-row justify-between w-full">
                  <div className="text-gray-600 font-normal text-sm">Invoices</div>
                  <div className="TEXT_PRIMARY-CLR font-semibold text-sm">
                    {invoiceCount} invoice{invoiceCount !== 1 ? 's' : ''}
                  </div>
                </div>
                {totalDiscount > 0 && (
                  <div className="flex flex-row justify-between w-full mt-1">
                    <div className="text-green-600 font-normal text-sm">Discount</div>
                    <div className="text-green-600 font-semibold text-sm">
                      -{formatMoney(totalDiscount, 2)}
                    </div>
                  </div>
                )}
                <div className="flex flex-row justify-between w-full mt-1">
                  <div className="text-gray-600 font-normal text-sm">Invoice Subtotal</div>
                  <div className="TEXT_PRIMARY-CLR font-semibold text-sm">
                    {formatMoney(invoiceSubtotal, 2)}
                  </div>
                </div>
                {creditsApplied > 0 && (
                  <div className="flex flex-row justify-between w-full mt-1">
                    <div className="text-green-600 font-normal text-sm">Credits Applied</div>
                    <div className="text-green-600 font-semibold text-sm">
                      -{formatMoney(creditsApplied, 2)}
                    </div>
                  </div>
                )}
                {excessAmount > 0 && (
                  <div className="flex flex-row justify-between w-full mt-1">
                    <div className="text-amber-600 font-normal text-sm">Open Payment</div>
                    <div className="text-amber-600 font-semibold text-sm">
                      {formatMoney(excessAmount, 2)}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="w-full">
            <div className="flex flex-col justify-between rounded-xl PRIMARY_50-BG px-5 py-4">
              <div className="flex flex-row justify-between w-full pt-2">
                <div className="PRIMARY_500-CLR font-normal">Total Payment</div>
                {paymentDetails && (
                  <div className="PRIMARY_500-CLR font-semibold text-lg">{`${formatMoney(
                    paymentDetails?.totalPayment,
                    2
                  )}`}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between  px-4 py-2 gap-2">
          <DillButton
            label={'Back'}
            variant="secondary"
            width="100%"
            onClick={() => handleClose()}
          />
          <DillButton label="Pay Now" width="100%" onClick={handlePayNow} />
        </div>
      </div>
    </Modal>
  );
};

export default PaymentConfirmationModal;
